module.exports = __webpack_public_path__ + "static/tachylogo-6d01ca054e8b0943c82eb5795d8efbc2.png";